const T_PREFIX = "responses";

export const successfulResponsesTrns = {
  default: `${T_PREFIX}.successful.default`,
  login: `${T_PREFIX}.successful.login`,
  resetPassword: `${T_PREFIX}.successful.reset-password`,
  updatePassword: `${T_PREFIX}.successful.update-password`,
  registration: `${T_PREFIX}.successful.registration`,
  googleAuth: `${T_PREFIX}.successful.google-auth`,
  clones: `${T_PREFIX}.successful.clones`,
  myClones: `${T_PREFIX}.successful.my-clones`,
  currentClone: `${T_PREFIX}.successful.currentClone`,
  inquiries: `${T_PREFIX}.successful.inquiries`,
  myInquiries: `${T_PREFIX}.successful.my-inquiries`,
  userProfileInquiries: `${T_PREFIX}.successful.user-profile-inquiries`,
  createClone: `${T_PREFIX}.successful.create-clone`,
  editClone: `${T_PREFIX}.successful.edit-clone`,
  deleteClone: `${T_PREFIX}.successful.delete-clone`,
  addingFavorite: `${T_PREFIX}.successful.adding-favorites`,
  removingFavorite: `${T_PREFIX}.successful.removeing-favorites`,
  addingWatchlist: `${T_PREFIX}.successful.adding-watchlist`,
  removingWatchlist: `${T_PREFIX}.successful.removeing-watchlist`,
  createDeal: `${T_PREFIX}.successful.creating-deal`,
  cancelDeal: `${T_PREFIX}.successful.canceling-deal`,
  doneDeal: `${T_PREFIX}.successful.done-deal`,
  deleteDeal: `${T_PREFIX}.successful.deleting-deal`,
  inProgressDeal: `${T_PREFIX}.successful.in-progressing-deal`,
  createInquiry: `${T_PREFIX}.successful.create-inquiry`,
  editInquiry: `${T_PREFIX}.successful.edit-inquiry`,
  deleteInquiry: `${T_PREFIX}.successful.delete-inquiry`,
  updateUser: `${T_PREFIX}.successful.update-user`,
  contactUs: `${T_PREFIX}.successful.contact-us`,
};

export const pendingResponsesTrns = {
  default: `${T_PREFIX}.pending.default`,
  clones: `${T_PREFIX}.pending.clones`,
  myClones: `${T_PREFIX}.pending.my-clones`,
  currentClone: `${T_PREFIX}.pending.currentClone`,
  inquiries: `${T_PREFIX}.pending.inquiries`,
  myInquiries: `${T_PREFIX}.pending.my-inquiries`,
  userProfileInquiries: `${T_PREFIX}.pending.user-profile-inquiries`,
  createClone: `${T_PREFIX}.pending.create-clone`,
  editClone: `${T_PREFIX}.pending.edit-clone`,
  deleteClone: `${T_PREFIX}.pending.delete-clone`,
  addingFavorite: `${T_PREFIX}.pending.adding-favorites`,
  removingFavorite: `${T_PREFIX}.pending.removeing-favorites`,
  createInquiry: `${T_PREFIX}.pending.create-inquiry`,
  editInquiry: `${T_PREFIX}.pending.edit-inquiry`,
  deleteInquiry: `${T_PREFIX}.pending.delete-inquiry`,
  addingWatchlist: `${T_PREFIX}.pending.adding-watchlist`,
  removingWatchlist: `${T_PREFIX}.pending.removeing-watchlist`,
  updateUser: `${T_PREFIX}.pending.update-user`,
};

export const errorResponsesTrns = {
  default: `${T_PREFIX}.error.default`,
  login: `${T_PREFIX}.error.login`,
  resetPassword: `${T_PREFIX}.error.reset-password`,
  updatePassword: `${T_PREFIX}.error.update-password`,
  registration: `${T_PREFIX}.error.registration`,
  googleAuth: `${T_PREFIX}.error.google-auth`,
  industries: `${T_PREFIX}.error.industries`,
  industry: `${T_PREFIX}.error.industry`,
  investments: `${T_PREFIX}.error.investments`,
  prices: `${T_PREFIX}.error.prices`,
  cloneTypes: `${T_PREFIX}.error.clone-types`,
  countries: `${T_PREFIX}.error.countries`,
  soldInformations: `${T_PREFIX}.error.sold-informations`,
  clones: `${T_PREFIX}.error.clones`,
  myClones: `${T_PREFIX}.error.my-clones`,
  currentClone: `${T_PREFIX}.error.current-clone`,
  inquiries: `${T_PREFIX}.error.inquiries`,
  myInquiries: `${T_PREFIX}.error.my-inquiries`,
  userProfileInquiries: `${T_PREFIX}.error.user-profile-inquiries`,
  currentInquiry: `${T_PREFIX}.error.current-inquiry`,
  createClone: `${T_PREFIX}.error.create-clone`,
  editClone: `${T_PREFIX}.error.edit-clone`,
  deleteClone: `${T_PREFIX}.error.delete-clone`,
  addingFavorite: `${T_PREFIX}.error.adding-favorites`,
  removingFavorite: `${T_PREFIX}.error.removeing-favorites`,
  gettingFavorites: `${T_PREFIX}.error.getting-favorites`,
  addingWatchlist: `${T_PREFIX}.error.adding-watchlist`,
  removingWatchlist: `${T_PREFIX}.error.removeing-watchlist`,
  gettingWatchlist: `${T_PREFIX}.error.getting-watchlist`,
  gettingDeals: `${T_PREFIX}.error.getting-deals`,
  createDeal: `${T_PREFIX}.error.creating-deal`,
  cancelDeal: `${T_PREFIX}.error.canceling-deal`,
  doneDeal: `${T_PREFIX}.error.done-deal`,
  deleteDeal: `${T_PREFIX}.error.deleting-deal`,
  inProgressDeal: `${T_PREFIX}.successful.in-progressing-deal`,
  createInquiry: `${T_PREFIX}.error.create-inquiry`,
  editInquiry: `${T_PREFIX}.error.edit-inquiry`,
  deleteInquiry: `${T_PREFIX}.error.delete-inquiry`,
  updateUser: `${T_PREFIX}.error.update-user`,
  gettingChat: `${T_PREFIX}.error.getting-chat`,
  sendMessage: `${T_PREFIX}.error.sending-message`,
  gettingBlogPosts: `${T_PREFIX}.error.getting-blog-posts`,
  gettingBlogCategories: `${T_PREFIX}.error.getting-blog-categories`,
  gettingCurentBlogPost: `${T_PREFIX}.error.getting-current-blog-post`,
  contactUs: `${T_PREFIX}.error.contact-us`,
};
